<template>
  <div class="smart-detection-state-manage">
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="search-line">
      <div class="btn-box">
        <input-select selectTitle="所属场所" :selectKey="'placeCode'" selectWidth="180px" :selectData="sceneList" @search="search" style="margin-right: 10px;"/>
        <input-select selectTitle="监测状态" :selectKey="'monitorStatus'" selectWidth="180px" :selectData="stateList" @search="search" style="margin-right: 10px;"/>
      </div>
      <input-search placeholder="监测点/监测点编号" @search="searchKey"/>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData"
                :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize"
                :hasOperation="false" @changePagination="changePagination"/>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import {api} from "../../api/SmartDetection";
import {errorHandler} from "../../../utils/errorHandler";
import {nAlert, nError, nSuccess} from "../../../utils/notice";
import {bus} from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "smart-detection-state-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "配电监测",
          name: "smart-detection-over-view"
        },
        {
          value: "状态传感器监测"
        }
      ],
      stateList: [
        { key: "", label: "全部" },
        { key: "正常", label: "正常" },
        { key: "异常", label: "异常" }
      ],

      tableHead: [
        {
          prop: "deviceName",
          label: "监测点"
        },
        {
          prop: "deviceCode",
          label: "监测点编号"
        },
        {
          prop: "deviceManufacturerName",
          label: "所属场所"
        },
        {
          prop: "deviceManufacturerName",
          label: "监测状态"
        },
        {
          prop: "deviceManufacturerName",
          label: "监测时间"
        }
      ],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        deviceType: "",
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      sceneList:[]
    };
  },
  created() {
    this.getPage()
    this.getPlaceList()
  },
  activated() {
    this.getPage()
  },
  methods: {
    getPlaceList(searchKey) {
      this.$axios
        .post(api.getPlaceList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              v.key = v.code;
              v.label = v.name;
            });
            this.sceneList = list;
            this.sceneList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    getPage() {
      this.$axios
        .post(api.getTouchRunMonitorPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              v.code = v.deviceCode;
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },
    search(v) {
      this.requestData.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    goToModifyPage(code) {
      this.$router.push({
        path: "/smart_detection_power_distribution_cabinet_modify/" + code
      });
    },

    deleteLine(code) {
      this.$axios
        .post(api.deletePowerBoxByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    }
  },
  watch: {
    centEndTime(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.form-line {
  width: 420px;
  margin: 20px auto;
  display: flex;
  justify-content: flex-start;
}

.form-line > div {
  margin-right: 20px;
}

.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}

.textBox {
  display: inline-block;
  width: 122px;
  line-height: 32px;
  text-align: right;
}

.red {
  color: red;
}

.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionOperationMonitoring/SmartDetectionStateMonitoring.vue